import React from 'react';
import { Card, Descriptions, Empty, Button, Typography } from 'antd';
import { IContractor } from '../../types/contractor';
import { AvailableArea } from '../Plans/AvailableArea';

const { Title } = Typography;

interface ContractorInfoCardProps {
  contractor?: IContractor | null;
  isContractorUser: boolean;
  onEdit?: () => void;
  showEditAction?: boolean;
}

export const ContractorInfoCard: React.FC<ContractorInfoCardProps> = ({
  contractor,
  isContractorUser,
  onEdit,
  showEditAction = false,
}) => {
  if (!isContractorUser) {
    return null;
  }

  const hasAvailableArea =
    (contractor?.availableArea?.states?.length || 0) > 0 ||
    (contractor?.availableArea?.counties?.length || 0) > 0;

  return (
    <Card
      hoverable
      style={{ width: '100%' }}
      bodyStyle={{ padding: 24 }}
      title="Contractor Info"
      extra={
        showEditAction && (
          <Button type="link" onClick={onEdit}>
            {contractor ? 'Edit Contractor Info' : 'Complete Profile'}
          </Button>
        )
      }>
      {contractor ? (
        <>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Company">{contractor.name}</Descriptions.Item>
            <Descriptions.Item label="Phone">{contractor.phone}</Descriptions.Item>
            <Descriptions.Item label="Email">{contractor.email}</Descriptions.Item>
            <Descriptions.Item label="Description">
              {contractor.description || 'Not provided'}
            </Descriptions.Item>
          </Descriptions>
          <div style={{ marginTop: 16 }}>
            <Title level={5} style={{ marginBottom: 8 }}>
              Available Area
            </Title>
            {hasAvailableArea ? (
              <AvailableArea
                available={{
                  states: contractor.availableArea?.states || [],
                  counties: contractor.availableArea?.counties || [],
                  cities: [],
                }}
              />
            ) : (
              <Typography.Text type="secondary">
                Available in all states and counties
              </Typography.Text>
            )}
          </div>
        </>
      ) : (
        <Empty description="Contractor details are required to continue." />
      )}
    </Card>
  );
};
